import { AnimatePresence, motion } from "framer-motion";
import { BsHandbag, BsHandbagFill } from "react-icons/bs";
import { GoHeart, GoHeartFill } from "react-icons/go";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";

import { FaCheck } from "react-icons/fa6";
import { FiSearch } from "react-icons/fi";
import { GoPerson } from "react-icons/go";
import LoaderMini from "../../Loader/LoaderMini";
import LoginPopup from "../../Popup/Login/LoginPopup";
import MobileAppBanner from "../../MobileAppBanner/MobileAppBanner";
import { MobileNav } from "./MobileNav/MobileNav";
import RegisterPopup from "../../Popup/Register/RegisterPopup";
import { RiArrowDownSLine } from "react-icons/ri";
import SearchPopup from "../../Search/SearchPopup";
import avatar from "../../../assets/images/user 5.png";
import contact_icon from "../../../assets/icons/Contact_icon.png";
import delivery_icon from "../../../assets/icons/Delivery_icon.png";
import { fetchCities } from "../../../redux/slices/citiesSlice";
import { fetchUserProfile } from "../../../redux/slices/userProfileSlice";
import location_icon from "../../../assets/icons/Location_icon.png";
import logo_full from "../../../assets/icons/Logo_Full.webp";
import { logout } from "../../../redux/slices/authSlice";
import { selectCartItems } from "../../../redux/slices/cartSlice";
import { selectFavorites } from "../../../redux/slices/favoritesSlice";
import { setCity } from "../../../redux/slices/citySelectionSlice";
import { useTranslation } from "react-i18next";

const Nav = () => {
  const dispatch = useDispatch();
  const [showLanguages, setShowLanguages] = useState(false);
  const [showCities, setShowCities] = useState(false);
  const [showLoginForm, setShowLoginForm] = useState(false);
  const [showRegisterForm, setShowRegisterForm] = useState(false);
  const [showSearchPopup, setShowSearchPopup] = useState(false);
  const favorites = useSelector(selectFavorites);
  const cartItems = useSelector(selectCartItems);
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const isEng = i18n.language === "en";
  const { categories, loading: categoriesLoading } = useSelector(
    (state) => state.categories
  );

  const handleToggleLanguages = () => {
    setShowLanguages((prev) => !prev);
  };

  const handleShowCities = () => {
    setShowCities((prev) => !prev);
  };

  const handleShowSearch = () => {
    setShowSearchPopup(prev => !prev);
  };

  const { cities } = useSelector((state) => state.cities);

  useEffect(() => {
    dispatch(fetchCities());
  }, [dispatch]);

  const selectedCity = useSelector((state) => state.citySelection.selectedCity);

  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };


  const handlePopup = (type) => {
    if (type === "login") {
      setShowLoginForm((prev) => !prev);
      setShowRegisterForm(false);
    }
    if (type === "register") {
      setShowRegisterForm((prev) => !prev);
      setShowLoginForm(false);
    }
  };
  useEffect(() => {
    if (isAuthenticated) {
      dispatch(fetchUserProfile());
    }
  }, [dispatch, isAuthenticated]);

  useEffect(() => {
    if (showLoginForm) {
      setShowRegisterForm(false);
    }
    if (showRegisterForm) {
      setShowLoginForm(false);
    }
  }, [showLoginForm, showRegisterForm]);

  useEffect(() => {
    if (selectedCity) {
      setShowCities(false);
    }
  }, [selectedCity]);

  return (
    <nav
      className="flex items-center justify-center w-screen sticky top-0 z-50
     bg-white shadow-md"
    >
      <div className="w-full flex flex-col items-center justify-center ">
        <MobileAppBanner />

        {/* top-side */}
        <div
          className="flex items-center justify-center w-full h-[3.5rem] 
        border-b border-blue-2"
        >
          <div className="flex items-center justify-between w-[90%] lg:max-w-[1300px]">
            {/* delivery - left side*/}
            <div className="flex items-center justify-center gap-3 h-full">
              <div className="flex items-center justify-center gap-2 ">
                <div className="flex items-center justify-center">
                  <img
                    src={delivery_icon}
                    alt="delivery"
                    className="w-[2.45rem] h-[1.63rem] "
                  />
                </div>
                <p className="text-[16px] leading-[20px] text-[#402D7E] font-[500]">
                  {t("free_delivery")}
                </p>
              </div>
              <div className="hidden md:flex items-center justify-center gap-3 h-full">
                <div className="flex items-center justify-center">
                  <img
                    src={contact_icon}
                    alt="contact"
                    className="w-[25px] h-[25px]"
                  />
                </div>
                <div className="flex flex-col items-start justify-center text-[#402D7E]">
                  <p className="text-[12px] leading-[16px] tracking-[0.15px] font-normal">
                    {t("hotline")}
                  </p>
                  <p className="text-[16px] leading-[20px] tracking-[32%] font-medium">
                    0536679457
                  </p>
                </div>
              </div>
            </div>
            {/* right side  */}
            <div className="flex items-center jsutify-center gap-1 h-[3.5rem]">
              <div className="flex items-center justify-center gap-2">
                {/*  icon*/}
                <div className="flex items-center justify-center h-full">
                  <img
                    src={location_icon}
                    alt="location_icon"
                    className="w-[17px] h-[23px] "
                  />
                </div>
                {/* text */}
                <div
                  onClick={handleShowCities}
                  className="flex flex-col items-start justify-center relative cursor-pointer"
                >
                  <p
                    className="hidden md:flex font-normal text-xs
                text-[#402D7E]"
                  >
                    {t("delivery_to")}
                  </p>
                  <p className="text-[#402D7E] text-xs font-medium">
                    {isEng ? selectedCity?.e_name : selectedCity?.a_name}
                  </p>
                  <AnimatePresence>
                    {showCities ? (
                      <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "11rem" }}
                        exit={{ opacity: 0, height: 0 }}
                        className={`flex flex-col gap-2 items-start justify-center py-2
                  absolute top-full w-[10rem] rounded-lg overflow-y-scroll no-scrollbar bg-white p-2 shadow-lg
                   translate-y-2 shadow-black z-10 
                   ${i18n.language === "en" ? "right-0" : "left-0"}`}
                      >
                        {cities?.map((city, index) => (
                          <button
                            type="button"
                            key={city?.id}
                            className={`flex items-center justify-between w-full gap-1
                        h-[24px] hover:bg-gray-300 p-2 rounded-lg 
                        ease-in-out duration-100 `}
                            onClick={() => {
                              dispatch(setCity(city));
                              setShowCities((prev) => !prev);
                            }}
                          >
                            <p>{isEng ? city?.e_name : city?.a_name}</p>
                            <p className=" text-sm flex items-center justify-center">
                              {selectedCity?.id === city?.id ? (
                                <FaCheck />
                              ) : null}
                            </p>
                          </button>
                        ))}
                      </motion.div>
                    ) : null}
                  </AnimatePresence>
                </div>
              </div>
              <div
                onClick={handleToggleLanguages}
                className="flex items-center justify-center 
                text-[#402D7E] relative cursor-pointer"
              >
                {/* arrow-icon */}
                <motion.div
                  animate={{ rotate: showLanguages ? "180deg" : "0deg" }}
                  className="flex items-center justify-center w-[24px] 
                  h-[24px]"
                >
                  <RiArrowDownSLine size={15} />
                </motion.div>
                <div className="flex items-center justify-center h-full">
                  <p className="text-xs font-medium text-center ">
                    {i18n.language === "ar" ? "العربيه" : "English"}
                  </p>
                </div>
                <AnimatePresence>
                  {showLanguages ? (
                    <motion.div
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: "5rem" }}
                      exit={{ opacity: 0, height: 0 }}
                      className={`flex flex-col gap-2 items-center justify-center 
                  absolute top-full w-[10rem] rounded-lg overflow-hidden bg-white p-2 shadow-lg
                   translate-y-2 shadow-black z-10 
                   ${i18n.language === "en" ? "right-0" : "left-0"}`}
                    >
                      <button
                        type="button"
                        className={`flex items-center justify-between w-full gap-1
                        h-[24px] hover:bg-gray-300 p-2 rounded-lg ease-in-out 
                        duration-100 font-tajawal`}
                        onClick={() => {
                          i18n.changeLanguage("en");
                          localStorage.setItem("i18nextLng", "en");
                        }}
                      >
                        <p>English</p>
                        <p className=" text-sm flex items-center justify-center">
                          {i18n.language === "en" ? <FaCheck /> : null}
                        </p>
                      </button>
                      <button
                        type="button"
                        className={`flex items-center justify-between w-full gap-1
                        h-[24px] hover:bg-gray-300 p-2 rounded-lg ease-in-out duration-100`}
                        onClick={() => {
                          i18n.changeLanguage("ar");
                          localStorage.setItem("i18nextLng", "ar");
                        }}
                      >
                        <p className="font-tajawal">العربية</p>
                        <p className="w-[24px] h-[24px] flex items-center justify-center">
                          {i18n.language === "ar" ? <FaCheck /> : null}
                        </p>
                      </button>
                    </motion.div>
                  ) : null}
                </AnimatePresence>
              </div>
            </div>
          </div>
        </div>
        {/* down-side menu */}
        <div className="flex items-center justify-between w-[90%] lg:max-w-[1300px]">
          <div
            className="flex items-center justify-center w-full py-5
          "
          >
            <div className="flex items-center justify-between w-full">
              {/* left-side */}

              <div className="flex items-center justify-center gap-2">
                <MobileNav
                  isAuthenticated={isAuthenticated}
                  user={user}
                  handleLogout={handleLogout}
                  handlePopup={handlePopup}
                />
                <div>
                  <Link to="/">
                    <img
                      src={isEng ? logo_full : logo_full}
                      alt="logo"
                      className={` h-[45px] w-[120px] md:h-[65.26px] lg:w-full 
                      object-cover `}
                    />
                  </Link>
                </div>
              </div>
              {/* middle - menu */}
              <div className="hidden md:flex items-center justify-center gap-2 text-[#402D7E]">
                {categoriesLoading ? (
                  <div className="flex items-center justify-center">
                    <LoaderMini color="bg-blue-500" />
                  </div>
                ) : (
                  <div className="flex items-center justify-center gap-2">
                    {categories?.map((category) => (
                      <div
                        key={category.id}
                        className="flex items-center justify-center  border-gray-300
                relative group p-2"
                      >
                        <Link to={`/categories/${category.id}`}>
                          <button className={``}>
                            {i18n.language === "en"
                              ? category.english_name
                              : category.arabic_name}
                          </button>
                        </Link>
                        <span
                          className={`flex absolute top-full w-full h-[1px] bg-gray-400 
                    opacity-0 group-hover:opacity-100 duration:300 transition-opacity
                    `}
                        ></span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {/* right-side */}
              <div className="flex items-center justify-center gap-2 md:gap-4">
                <div className="flex items-center justify-center text-[#402D7E]">
                  <motion.button
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    className="flex items-center justify-center w-[24px]  
                    h-[24px] hover:text-blue-400"
                    onClick={handleShowSearch}
                  >
                    <FiSearch size={21} />
                  </motion.button>
                </div>
                <div className="flex items-center justify-center text-[#402D7E] relative">
                  <motion.button
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    className="flex items-center justify-center w-[24px] h-[24px] 
                    hover:text-blue-400 "
                  >
                    <Link to="/cart">
                      {cartItems?.length > 0 ? (
                        <BsHandbagFill size={21} className="text-blue-2" />
                      ) : (
                        <BsHandbag size={21} />
                      )}
                    </Link>
                  </motion.button>
                  {cartItems?.length > 0 ? (
                    <div
                      className="absolute top-0 right-0 w-4 h-4 
                    rounded-full bg-blue-2 text-white flex 
                    items-center justify-center translate-x-2 -translate-y-2 text-xs"
                    >
                      {cartItems?.length}
                    </div>
                  ) : null}
                </div>
                <div className="flex items-center justify-center text-[#402D7E] relative">
                  <Link to="/profile/favorites">
                    <motion.button
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.9 }}
                      className="flex items-center justify-center w-[24px] h-[24px]"
                    >
                      {favorites?.length > 0 && isAuthenticated ? (
                        <GoHeartFill size={24} className="text-red-500" />
                      ) : (
                        <GoHeart size={24} className="hover:fill-red-500" />
                      )}
                    </motion.button>
                  </Link>
                  {favorites?.length > 0 && isAuthenticated ? (
                    <div
                      className="absolute top-0 right-0 w-4 h-4 
                    rounded-full bg-red-500 text-white flex 
                    items-center justify-center translate-x-2 -translate-y-2 text-xs"
                    >
                      {favorites?.length}
                    </div>
                  ) : null}
                </div>
                <div className="flex items-center justify-center text-[#402D7E] flex-shrink-0">
                  <div className="flex items-center justify-center">
                    {isAuthenticated ? (
                      <div className="flex items-center justify-center">
                        <Link to="/profile">
                          <img
                            src={user?.avatar || avatar}
                            alt="profile"
                            className="w-6 h-6 rounded-full 
                              object-cover border border-blue-500 hover:border-black"
                          />
                        </Link>
                      </div>
                    ) : (
                      <div className="flex items-center justify-center">
                        <button
                          className="flex items-center justify-center 
                          hover:text-blue-300  w-[24px] h-[24px]"
                          onClick={() => handlePopup("login")}
                        >
                          <GoPerson size={24} />
                        </button>
                      </div>
                    )}
                  </div>
                </div>
                {showLoginForm ? (
                  <LoginPopup
                    setShowLoginForm={setShowLoginForm}
                    setShowRegisterForm={setShowRegisterForm}
                    showRegisterForm={showRegisterForm}
                    handlePopup={handlePopup}
                  />
                ) : null}
                {showRegisterForm ? (
                  <RegisterPopup
                    setShowRegisterForm={setShowRegisterForm}
                    setShowLoginForm={setShowLoginForm}
                    showLoginForm={showLoginForm}
                    handlePopup={handlePopup}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <AnimatePresence>
          {showSearchPopup && (
            <SearchPopup setShowSearchPopup={setShowSearchPopup} showSearchPopup={showSearchPopup} />
          )}
        </AnimatePresence>
      </div>
    </nav>
  );
};

export default Nav;
